(() => {
 const init=()=>{
  document.querySelectorAll('[data-atr-shop-menu]').forEach(root=>{
   if(root.dataset.ready)return;root.dataset.ready='true';const button=root.querySelector('[data-shop-toggle]'),panel=root.querySelector('.atr-shop-panel');
   let closeTimer;const open=()=>{clearTimeout(closeTimer);panel.hidden=false;button.setAttribute('aria-expanded','true');};const close=()=>{clearTimeout(closeTimer);panel.hidden=true;button.setAttribute('aria-expanded','false');};
   button.addEventListener('click',()=>panel.hidden?open():close());
   root.addEventListener('mouseenter',()=>{if(matchMedia('(min-width:1100px) and (hover:hover)').matches)open();});
   root.addEventListener('mouseleave',()=>{if(!root.contains(document.activeElement))closeTimer=setTimeout(close,180);});
   root.addEventListener('focusout',()=>setTimeout(()=>{if(!root.contains(document.activeElement))close();},0));
   root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){close();button.focus();}});
   document.addEventListener('click',e=>{if(!root.contains(e.target))close();});
  });
  document.querySelectorAll('.atr-card-quick').forEach(details=>{
   if(details.dataset.ready)return;details.dataset.ready='true';
   details.addEventListener('toggle',()=>{if(details.open)document.querySelectorAll('.atr-card-quick[open]').forEach(other=>{if(other!==details)other.open=false;});});
   details.addEventListener('keydown',e=>{if(e.key==='Escape'){details.open=false;details.querySelector('summary').focus();}});
   document.addEventListener('click',e=>{if(details.open&&!details.contains(e.target))details.open=false;});
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

